module.exports = __webpack_public_path__ + "static/media/busd.61ed49e5.svg";